module.exports = __webpack_public_path__ + "static/media/VENICE.1ee77022.mp4";